import React, { useEffect, useState, useCallback } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import { useTranslation } from "react-i18next";
import { useDropzone } from "react-dropzone";
import interact from "interactjs";
import SignaturePad from "signature_pad";
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
import { initializeIcons } from "@fluentui/font-icons-mdl2";
import moment from "moment";
import "./css/PdfSidebar.css";
import "./css/OverrideReactPdf.css";
import { FontIcon } from "@fluentui/react/lib/Icon";
import { DefaultButton, Spinner, Stack, PrimaryButton, Slider } from "@fluentui/react";
import { mergeStyles } from "@fluentui/react/lib/Styling";
import { jsPDF } from "jspdf";
import "svg2pdf.js";
// import { promptVar, sarabunVar, sorceSerifVar } from "./myFontVar";
import { UploadFile } from "../../../api_function/uploadDigitalSignature";
import { DownloadFile } from "../../../api_function/downloadDigitalSignature";
import { DeleteFile } from "../../../api_function/deleteDigitalSignature";
import { UploadPDF } from "../../../api_function/uploadPDF";
import { DeletePDF } from "../../../api_function/deletePDF";
import { UploadStamp } from "../../../api_function/uploadStamp";
import { DownloadStamp } from "../../../api_function/downloadStamp";
import { DeleteStamp } from "../../../api_function/deleteStamp";
import { useSessionStorage } from "../../../session_storage/Session";
import { useLocalStorage } from "../../../local_storage/LocalStorage";

const PdfWindow = (props) => {
  const { t } = useTranslation(); //translation
  const [isSignBox, setSignBox] = useState(false); //Show signbox upload/sign | true : show, false : hide
  const [isConfirmSignDelete, setConfirmSignDelete] = useState(false); //Delete confirm popup | true : show, false : hide
  const [imageSaving, setImageSaving] = useState(); //Sign image | true : uploaded image, null : not uploaded
  const [stampSaving, setStampSaving] = useState(); //stamp image | true : uploaded image, null : not uploaded
  const [signNum, setSignNum] = useState(0); //page of signs on PDF | number
  const [signOptionBox, setSignOptionBox] = useState(); //Option box for user to change properties of element on PDF | id : show, false : hide
  const [textNum, setTextNum] = useState(0); //page of texts on PDF | number
  const [textOptionBox, setTextOptionBox] = useState(); //Option box for user to change properties of element on PDF | id : show, false : hide
  const [trueCopyNum, setTrueCopyNum] = useState(0); //number of certificated true copy texts duplicated | number
  const [checkBoxNum, setCheckBoxNum] = useState(0); //number of checkboxs duplicated | number
  const [stampNum, setStampNum] = useState(0); //number of stamp duplicated | number
  const [signUploadSelected, setSignUploadSelected] = useState(false); //Upload page when select your sign | true : upload dropzone, false : none
  const [signDrawSelected, setSignDrawSelected] = useState(false); //Draw page when select your sign | true : signature pad, false : none
  const [signTypeSelected, setSignTypeSelected] = useState(false); //Type page when select your sign | true : textbox, false : none
  const [stampUploading, setStampUploading] = useState(false); //Upload stamp popup | true : upload drop box, false : none
  const [stampName, setStampName] = useState(""); //stamp origianl file name
  const [stampCropping, setStampCropping] = useState(false); //Crop stamp popup | true : crop box, false : none
  const [isConfirmStampDelete, setConfirmStampDelete] = useState(false);
  const [isColoring, setColoring] = useState(false); //Is user changing color of checkbox? | true : colorbox appear, false : option box appear
  const [isExporting, setExporting] = useState(false); //Is user exporting? | true : exporting, false : not exporting
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0] || {});

  const [penSize, setPenSize] = useState(0.5); //pen size for signature pad
  const [signaturePad, setSignaturePad] = useState(); //store signature pad in canvas

  const [, setFlowSelecting] = useSessionStorage("flowSelecting", "signed");
  const [, setMonthSelecting] = useLocalStorage(
    "monthSelecting",
    parseInt(moment().format("MM"))
  );
  const [, setYearSelecting] = useLocalStorage(
    "yearSelecting",
    parseInt(moment().format("YYYY"))
  );

  const potrace = require("potrace");
  // const fs = require("fs");

  initializeIcons();
  const iconClass = mergeStyles({
    fontSize: 50,
    height: 50,
    width: 50,
  });
  const iconMediumClass = mergeStyles({
    fontSize: 40,
  });
  const iconSmallClass = mergeStyles({
    fontSize: 20,
  });

  const spinnerStyles = {
    circle: {
      height: 30,
      width: 30,
      borderWidth: 4,
    },
  };

  const spinnerStylesLarge = {
    circle: {
      height: 56,
      width: 56,
      borderWidth: 4,
    },
  };

  var pdfDoc = null,
    pageNum = 1,
    pageRendering = false,
    pageNumPending = null,
    scale = 1,
    canvasArr = [];

  interact(".mobile-dropable").dropzone({
    // only accept elements matching this CSS selector
    accept: ".resizable",
    // Require a 75% element overlap for a drop to be possible
    overlap: 0.75,
    ondrop: function (event) {
      console.log("dropped");
    },
  });

  function potracing(xmlStr, filename, color = "black") {
    document.getElementById("addSignature").onclick = null;
    let trace = new potrace.Potrace();
    trace.loadImage(xmlStr, function (err) {
      if (err) throw err;
      xmlStr = trace.getSVG();
      let parser = new DOMParser();
      let doc = parser.parseFromString(xmlStr, "text/html");
      let svgPar = doc.body.childNodes[0];
      svgPar.xmlns = "http://www.w3.org/1999/xhtml";
      svgPar.childNodes.forEach((child) => {
        if (child.tagName === "path") {
          child.setAttribute("fill", color);
        }
      });
      let serializer = new XMLSerializer();
      xmlStr = serializer.serializeToString(doc);
      let payload = {
        selectedFile: xmlStr,
        instance: instance,
        account: account,
        name: filename,
      };
      document.getElementById("signtitle").style.display = "none";
      document.getElementById("signloading").style.display = "inline";
      document.getElementById("addSignature").style.pointerEvents = "none";
      UploadFile(payload).then(() => {
        let parser = new DOMParser();
        let doc = parser.parseFromString(xmlStr, "text/html");
        let svg = doc.body.childNodes[0];
        svg.classList.add("dup-drag-drop");
        svg.style.height = "50";
        svg.style.width = "75";
        document.getElementById("imagediv").appendChild(svg);
        document.querySelector(".mobile-signside").style.display = "grid";
        document.querySelector(".mobile-miniside").style.display = "none";
        document.getElementById("signtitle").style.display = "inline";
        document.getElementById("signloading").style.display = "none";
        document.getElementById("addSignature").style.pointerEvents = "auto";
        setImageSaving(true);
      });
    });
    setSignBox(false);
  }

  //Image Dropzone
  const onDrop = useCallback(
    (acceptedFiles) => {
      //anti-multifile fitler
      if (acceptedFiles[1]) {
        alert(t("Please input only one file at once."));
        return;
      }
      //extension file validation
      let fileExt = acceptedFiles[0].name.split(".");
      let lowerExt = fileExt[fileExt.length - 1].toLowerCase();
      if (lowerExt !== "png" && lowerExt !== "jpg" && lowerExt !== "jpeg") {
        alert(t("Please input jpg or png file only."));
        return;
      }
      const reader = new FileReader();

      reader.onabort = () => console.log("file reading was aborted");
      reader.onerror = () => console.log("file reading has failed");
      reader.onload = () => {
        //file
        let binaryStr = reader.result;
        let splitArr = acceptedFiles[0].name.split(".");
        let splitname = "";
        for (let i = 0; i < splitArr.length; i++) {
          if (i < splitArr.length - 1) {
            splitname += splitArr[i];
          }
        }
        splitname += ".svg";
        if (isSignBox && signUploadSelected) {
          potracing(binaryStr, splitname);
        } else if (stampUploading) {
          setStampName(splitname);
          setStampCropping(binaryStr);
        }
      };
      reader.readAsDataURL(acceptedFiles[0]);
    },
    [signUploadSelected, stampUploading]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  //duplicated dragable element
  // interact(".dup-drag-drop").draggable({
  //   inertia: false,
  //   autoScroll: true,
  //   listeners: { start: dupElement, move: dragMoveListener, end: isDelElement },
  // });
  interact(".drag-drop").draggable({
    inertia: false,
    autoScroll: true,
    listeners: {
      start: removeEditable,
      move: dragMoveListener,
      end: recoverEditable,
    },
  });
  interact(".nonedit-drag-drop").draggable({
    inertia: false,
    autoScroll: true,
    listeners: {
      move: dragMoveListener,
    },
  });
  interact(".resizable")
    .resizable({
      // resize from all edges and corners
      edges: { left: true, right: true, bottom: true, top: true },
      listeners: {
        start(event) {
          ["touchstart", "touchmove", "touchend"].forEach((et) =>
            event.target.addEventListener(et, ignoreTouch)
          );
        },
        move(event) {
          var target = event.target;

          var x = parseFloat(target.getAttribute("data-x")) || 0;
          var y = parseFloat(target.getAttribute("data-y")) || 0;

          // update the element's style
          target.style.width = event.rect.width + "px";
          target.style.height = event.rect.height + "px";

          // translate when resizing from top or left edges
          x += event.deltaRect.left;
          y += event.deltaRect.top;

          target.style.transform = "translate(" + x + "px," + y + "px)";

          target.setAttribute("data-x", x);
          target.setAttribute("data-y", y);
        },
        end(event) {
          ["touchstart", "touchmove", "touchend"].forEach((et) =>
            event.target.removeEventListener(et, ignoreTouch)
          );
        },
      },
      modifiers: [
        // keep the edges inside the parent
        // interact.modifiers.restrictEdges({
        //   outer: "parent",
        // }),

        // minimum size
        interact.modifiers.restrictSize({
          min: { width: 10, height: 10 },
        }),
      ],

      inertia: false,
    })
    .draggable({
      listeners: { move: dragMoveListener },
      inertia: false,
    });

  function ignoreTouch(event) {
    event.preventDefault();
  }
  function dragMoveListener(event) {
    let target = event.target;
    let targetOptionBox =
      document.getElementById("textOptionBox") ||
      document.getElementById("signOptionBox") ||
      document.getElementById("colorBox") || 
      null;
    // keep the dragged position in the data-x/data-y attributes
    let x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
    let y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;

    // translate the element
    target.style.transform = "translate(" + x + "px, " + y + "px)";
    if (targetOptionBox && target.classList.contains("resizable")) {
      targetOptionBox.style.transform = "translate(" + x + "px, " + y + "px)";
      if(document.getElementById("pdfviewer").getBoundingClientRect().top >= target.getBoundingClientRect().top - parseFloat(target.style.height)){
        targetOptionBox.style.top = (parseFloat(target.style.top) + parseFloat(target.style.height)).toString() + "px";
      }
      else{
        targetOptionBox.style.top = (parseFloat(target.style.top) - parseFloat(targetOptionBox.offsetHeight)).toString() + "px";
      }
    }

    // update the posiion attributes
    target.setAttribute("data-x", x);
    target.setAttribute("data-y", y);
  }
  function removeEditable(event) {
    let target = event.target;
    target.contentEditable = "false";
    target.style.userSelect = "none";
  }
  function recoverEditable(event) {
    let target = event.target;
    target.contentEditable = "true";
    target.style.userSelect = "auto";
  }

  useEffect(() => {
    var thisfile = props.file; //png file
    // Loaded via <script> tag, create shortcut to access PDF.js exports.
    var pdfjsLib = window["pdfjs-dist/build/pdf"];
    // const pdfjsLib = require("pdfjs-dist");

    // The workerSrc property shall be specified.
    pdfjsLib.GlobalWorkerOptions.workerSrc =
      "//mozilla.github.io/pdf.js/build/pdf.worker.js";

    // Asynchronous download of PDF
    var loadingTask;
    thisfile
      ? (loadingTask = pdfjsLib.getDocument(thisfile))
      : (loadingTask = pdfjsLib.getDocument("pdf-test.pdf"));

    async function renderPage(pageNumber, canvasPage) {
      if (canvasArr[pageNumber - 1]) canvasArr[pageNumber - 1] = canvasPage;
      else canvasArr.push(canvasPage);
      pageRendering = true;
      // Using promise to fetch the page
      return await pdfDoc.getPage(pageNumber).then(async function (page) {
        var viewport = page.getViewport({ scale: scale });
        canvasPage.height = viewport.height;
        canvasPage.width = viewport.width;

        // Render PDF page into canvas context
        var renderContext = {
          canvasContext: canvasPage.getContext("2d"),
          viewport: viewport,
        };
        var renderTask = page.render(renderContext);

        // Wait for rendering to finish
        return await renderTask.promise.then(async function () {
          pageRendering = false;
          if (pageNumPending !== null) {
            // New page rendering is pending
            await renderPage(pageNumPending);
            pageNumPending = null;
          }
        });
      });
    }

    //change page by click
    function jumpToPage(pageNumber) {
      var card = document.getElementById("cardpdf");
      var sumY = 0;
      for (let i = 0; i < pageNumber - 1; i++) {
        sumY += canvasArr[i].height;
      }
      card.scrollTo(0, sumY);
      document.getElementById("page_num").textContent = pageNumber;
    }

    /**
     * If another page rendering in progress, waits until the rendering is
     * finised. Otherwise, executes rendering immediately.
     */
    function queueRenderPage(num) {
      if (pageRendering) {
        pageNumPending = num;
      } else {
        jumpToPage(num);
      }
    }

    /**
     * @function isDisable check if prev and next page button should disable or not
     */
    function isDisable() {
      if (pageNum <= 1) { 
        document.getElementById("prev").disabled = true;
        document.getElementById("prev").style.backgroundColor = "gray";
        document.getElementById("prev").style.cursor = "default"
      }
      else {
        document.getElementById("prev").disabled = false;
        document.getElementById("prev").style.backgroundColor = "white";
        document.getElementById("prev").style.cursor = "pointer"
      }
      if (pageNum >= pdfDoc.numPages) { 
        document.getElementById("next").disabled = true;
        document.getElementById("next").style.backgroundColor = "gray";
        document.getElementById("next").style.cursor = "default"
      }
      else {
        document.getElementById("next").disabled = false;
        document.getElementById("next").style.backgroundColor = "white";
        document.getElementById("next").style.cursor = "pointer"
      }
    }

    /**
     * Displays previous page.
     */
    function onPrevPage() {
      if (pageNum <= 1) {
        return;
      }
      pageNum--;
      isDisable();
      queueRenderPage(pageNum);
    }
    document.getElementById("prev").addEventListener("click", onPrevPage);

    /**
     * Displays next page.
     */
    function onNextPage() {
      if (pageNum >= pdfDoc.numPages) {
        return;
      }
      pageNum++;
      isDisable();
      queueRenderPage(pageNum);
    }
    document.getElementById("next").addEventListener("click", onNextPage);

    //change page
    function changePageByScroll() {
      var card = document.getElementById("cardpdf");
      var y = card.scrollTop;
      let i = 0;
      for (; i < canvasArr.length; i++) {
        if (y >= canvasArr[i].height) y -= canvasArr[i].height;
        else break;
      }
      if (parseInt(document.getElementById("page_num").textContent) !== i + 1) {
        document.getElementById("page_num").textContent = i + 1;
        pageNum = i + 1;
      }
      isDisable();
    }
    document
      .getElementById("cardpdf")
      .addEventListener("scroll", changePageByScroll);
    document
      .getElementById("cardpdf")
      .addEventListener("wheel", changePageByScroll);

    function getTranslateX(e) {
      let style = window.getComputedStyle(e);
      let matrix =
        style.transform || style.webkitTransform || style.mozTransform;
      let matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(", ");
      return matrixValues[4];
    }
    function getTranslateY(e) {
      let style = window.getComputedStyle(e);
      let matrix =
        style.transform || style.webkitTransform || style.mozTransform;
      let matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(", ");
      return matrixValues[5];
    }

    function findPage(positionY, oldScale, newScale) {
      let y = parseFloat(positionY);
      let i = 1;
      let isCount = true;
      let canvasArr = document.querySelectorAll(".the-canvas");
      canvasArr.forEach((element) => {
        if (
          y >= parseFloat(element.height) * (oldScale / newScale) + 5 &&
          isCount
        ) {
          y -= parseFloat(element.height) * (oldScale / newScale) + 5;
          i++;
        } else {
          isCount = false;
        }
      });
      return i;
    }
    function moveElement(oldScale, newScale, oldOffsetWidth) {
      let obj = document.querySelectorAll(".scalable");
      let oldLeft = [];
      let oldTop = [];
      let oldOverflow = [];
      let oldWidth = [];
      let oldHeight = [];
      let oldFontSize = [];
      let oldTransX = [];
      let oldTransY = [];
      let i = 0;
      obj.forEach((element) => {
        let elementType = element.id.split("-"); //type check [0]:type [1]:id
        let page = findPage(element.style.top, oldScale, newScale);
        if (
          oldOffsetWidth >
          parseFloat(
            document.querySelectorAll(".the-canvas")[page - 1].offsetWidth *
              (oldScale / newScale)
          )
        ) {
          //if canvas width less than frame width then must substract overflow left position
          oldOverflow.push(
            oldOffsetWidth / 2 -
              (document.querySelectorAll(".the-canvas")[page - 1].offsetWidth *
                (oldScale / newScale)) /
                2
          );
        } else {
          oldOverflow.push(0);
        }
        oldLeft.push(parseFloat(element.style.left, 10));
        if (elementType[0] === "text" || elementType[0] === "copy") {
          //text
          oldFontSize.push(parseInt(element.style.fontSize) / oldScale);
        } else if (
          elementType[0] === "cln" ||
          elementType[0] === "check" ||
          elementType[0] === "stamp"
        ) {
          //sign
          oldFontSize.push(0);
        }
        oldTop.push(parseInt(element.style.top, 10) - 5 * (page - 1));
        oldWidth.push(parseFloat(element.style.width) / oldScale);
        oldHeight.push(parseFloat(element.style.height) / oldScale);
        if (element.style.transform) {
          oldTransX.push(parseFloat(getTranslateX(element)));
          oldTransY.push(parseFloat(getTranslateY(element)));
        }
        i++;
      });
      let newPosX = 0;
      let newPosY = 0;
      let newTransX = 0;
      let newTransY = 0;
      let newWidth = 0;
      let newHeight = 0;
      i = 0;
      obj.forEach((element) => {
        let page = findPage(element.style.top, oldScale, newScale);
        if (
          oldOffsetWidth >
          parseFloat(
            document.querySelectorAll(".the-canvas")[page - 1].offsetWidth
          )
        ) {
          newPosX =
            (oldLeft[i] - oldOverflow[i]) * (newScale / oldScale) +
            document.getElementById("pdfviewer").offsetWidth / 2 -
            document.querySelectorAll(".the-canvas")[page - 1].offsetWidth / 2;
        } else {
          newPosX = (oldLeft[i] - oldOverflow[i]) * (newScale / oldScale);
        }
        newPosY = oldTop[i] * (newScale / oldScale) + 5 * (page - 1);
        element.style.left = newPosX + "px";
        element.style.top = newPosY + "px";
        if (oldFontSize[i] !== 0) {
          element.style.fontSize = (oldFontSize * newScale).toString() + "px";
        }
        newWidth = (oldWidth[i] * newScale).toString() + "px";
        newHeight = (oldHeight[i] * newScale).toString() + "px";
        element.style.width = newWidth;
        element.style.height = newHeight;
        if (oldFontSize[i] !== 0) {
          element.style.fontSize =
            (oldFontSize[i] * newScale).toString() + "px";
        }
        if (element.style.transform) {
          newTransX = oldTransX[i] * (newScale / oldScale);
          newTransY = oldTransY[i] * (newScale / oldScale);
          element.style.transform =
            "translate(" + newTransX + "px, " + newTransY + "px)";
        }
        i++;
      });
    }
    async function changeScale(newScale) {
      let oldScale = scale;
      let oldOffsetWidth = document.getElementById("pdfviewer").offsetWidth;
      scale = newScale;
      let promises = [];
      for (let i = 1; i <= canvasArr.length; i++) {
        let canvas = document.getElementById(i);
        let context = canvas.getContext("2d");
        await context.clearRect(0, 0, canvas.width, canvas.height);
        promises.push(await renderPage(i, canvas));
      }
      Promise.all(promises).then(() => {
        moveElement(oldScale, newScale, oldOffsetWidth);
        return true;
      });
    }
    async function fitToWidth() {
      let boxWidth = document.getElementById("cardpdf").offsetWidth;
      let oldOffsetWidth = document.getElementById("pdfviewer").offsetWidth;
      boxWidth = parseInt(boxWidth, 10);
      let oldScales = scale;
      let promises = [];
      for (let i = 1; i <= canvasArr.length; i++) {
        let canvas = document.getElementById(i);
        const context = canvas.getContext("2d");
        await context.clearRect(0, 0, canvas.width, canvas.height);
        scale = boxWidth / (canvas.width / oldScales) - 0.05;
        promises.push(await renderPage(i, canvas));
      }
      Promise.all(promises).then(() => {
        moveElement(oldScales, scale, oldOffsetWidth);
      });
    }
    /**
     * @param {number} newWidth width of pdf (px) (init: 1000)
     */
    const setPdfWidth = async (newWidth = 1000) => {
      let oldOffsetWidth = document.getElementById("pdfviewer").offsetWidth;
      let oldScales = scale;
      let promises = [];
      for (let i = 1; i <= canvasArr.length; i++) {
        let canvas = document.getElementById(i);
        const context = canvas.getContext("2d");
        await context.clearRect(0, 0, canvas.width, canvas.height);
        scale = newWidth / (canvas.width / oldScales);
        promises.push(await renderPage(i, canvas));
      }
      return Promise.all(promises).then(() => {
        moveElement(oldScales, scale, oldOffsetWidth);
        return true;
      });
    };
    document.getElementById("mobile-zoom").onchange = function zoomChange() {
      let newScale = document.getElementById("mobile-zoom").value;
      if (newScale !== "0") {
        changeScale(parseFloat(newScale));
      } else {
        fitToWidth(parseFloat());
      }
    };

    var windowHeight = window.innerHeight;
    var windowWidth = window.innerWidth;
    document.getElementById("cardpdf").style.width =
      windowWidth.toString() + "px";
    // document.getElementById("cardpdf").style.width = "100%";
    document.getElementById("cardpdf").style.height =
      (windowHeight * 0.8).toString() + "px";

    loadingTask.promise.then(
      async function (pdf) {
        pdfDoc = pdf;
        document.getElementById("page_count").textContent = pdfDoc.numPages;
        var viewer = document.getElementById("pdfviewer");
        for (let page = 1; page <= pdfDoc.numPages; page++) {
          let canvas = document.createElement("canvas");
          canvas.className = "the-canvas";
          canvas.id = page;
          viewer.appendChild(canvas);
          await renderPage(page, canvas);
          viewer.appendChild(document.createElement("br"));
        }
        isDisable();
        document.getElementById("page_num").textContent = 1;

        // // Fetch the first page
        // var pageNumber = 1;
        // pdf.getPage(pageNumber).then(function (page) {
        //   var viewport = page.getViewport({ scale: scale });

        //   // Prepare canvas using PDF page dimensions
        //   var canvas = document.getElementById("the-canvas");
        //   var context = canvas.getContext("2d");
        //   canvas.height = viewport.height;
        //   canvas.width = viewport.width;

        //   // Render PDF page into canvas context
        //   var renderContext = {
        //     canvasContext: context,
        //     viewport: viewport,
        //   };
        //   page.render(renderContext);
        // });
      },
      function (reason) {
        console.error(reason);
      }
    );

    if (document.getElementById("mobile-export")) {
      //export canvas to pdf
      document
        .getElementById("mobile-export")
        .addEventListener("click", function () {
          setFlowSelecting("signed");
          setMonthSelecting(moment().format("MM"));
          setYearSelecting(moment().format("YYYY"));
          let canvasWidth = document.getElementById("1").width;
          let canvasHeight = document.getElementById("1").height;
          document.getElementById("exporting").style.display = "inline";
          document.getElementById("cardpdf").style.visibility = "hidden";
          document.querySelector(".mobile-sidenav").style.visibility = "hidden";
          document.querySelector(".mobile-pdf-padding").style.visibility =
            "hidden";
          let promises = new Promise(async (resolve) => {
            await setPdfWidth(canvasHeight > canvasWidth ? 1000 : 1500);
            resolve();
          });
          promises.then(() => {
            setExporting(true);
            document.getElementById("lesspad").classList.remove("pdfscreen");
          });
        });
    }

    if (
      document.getElementById("mobile-sidenav-hide") &&
      document.querySelector(".mobile-sidenav")
    ) {
      document.getElementById("mobile-sidenav-hide").onclick =
        function hideNav() {
          document.querySelector(".mobile-sidenav").style.display = "none";
        };
    }
    if (
      document.getElementById("mobile-sidenav-show") &&
      document.querySelector(".mobile-sidenav")
    ) {
      document.getElementById("mobile-sidenav-show").onclick =
        function showNav() {
          document.querySelector(".mobile-sidenav").style.display = "block";
        };
    }

    //set CSS of pdf viewer
    document.getElementById("lesspad").classList.add("pdfscreen");

    if (!imageSaving) {
      let payload = {
        instance: instance,
        account: account,
      };
      document.getElementById("signtitle").style.display = "none";
      document.getElementById("signloading").style.display = "inline";
      document.getElementById("addSignature").style.pointerEvents = "none";
      DownloadFile(payload)
        .then((res) => {
          if (
            res &&
            props.file &&
            !isExporting &&
            document.querySelector(".mobile-signside")
          ) {
            // let datasvg = atob(res.replace(/data:image\/svg\+xml;base64,/, ""));
            let parser = new DOMParser();
            let doc = parser.parseFromString(res, "text/html");
            let svg = doc.body.childNodes[0];
            svg.classList.add("dup-drag-drop");
            svg.style.height = "50";
            svg.style.width = "75";
            document.getElementById("imagediv").appendChild(svg);
            document.querySelector(".mobile-signside").style.display = "grid";
            document.querySelector(".mobile-miniside").style.display = "none";
            document.getElementById("signtitle").style.display = "inline";
            document.getElementById("signloading").style.display = "none";
            document.getElementById("addSignature").style.pointerEvents = "auto";
            setImageSaving(true);
          }
        })
        .catch(() => {
          if (
            props.file &&
            !isExporting &&
            document.getElementById("signtitle")
          ) {
            document.getElementById("signtitle").style.display = "inline";
            document.getElementById("signloading").style.display = "none";
            document.getElementById("addSignature").style.pointerEvents = "auto";
          }
        });
    }
    if (!stampSaving) {
      let payload = {
        instance: instance,
        account: account,
      };
      document.getElementById("stamptitle").style.display = "none";
      document.getElementById("stamploading").style.display = "inline";
      document.getElementById("addStamp").style.pointerEvents = "none";
      DownloadStamp(payload)
        .then((res) => {
          if (
            res &&
            props.file &&
            !isExporting &&
            document.querySelector(".mobile-signside")
          ) {
            let parser = new DOMParser();
            let doc = parser.parseFromString(res, "text/html");
            let svgPar = doc.body.childNodes[0];
            document.getElementById("stampdiv").appendChild(svgPar);
            svgPar.style.height = "40px";
            svgPar.style.width = "40px";
            document.getElementById("mobile-stampside").style.display = "grid";
            document.getElementById("addStamp").style.display = "none";
            document.getElementById("stamptitle").style.display = "inline";
            document.getElementById("stamploading").style.display = "none";
            document.getElementById("addStamp").style.pointerEvents = "auto";
            svgPar.classList.add("stampimage");
            setStampSaving(true);
          }
        })
        .catch(() => {
          if (
            props.file &&
            !isExporting &&
            document.getElementById("stamptitle")
          ) {
            document.getElementById("stamptitle").style.display = "inline";
            document.getElementById("stamploading").style.display = "none";
            document.getElementById("addStamp").style.pointerEvents = "auto";
          }
        });
    }
  }, [props.file]);

  useEffect(() => {
    //export pdf
    if (isExporting) {
      // let promptFont = promptVar;
      // let sarabunFont = sarabunVar;
      // let sorceSerifFont = sorceSerifVar;
      let pdf = new jsPDF({ unit: "mm" });
      let canvaspdf = document.querySelectorAll(".the-canvas");
      let eleOnPdf = document.querySelectorAll(".scalable");
      let flag = 0;
      let orientation = "p";
      canvaspdf.forEach((canvas) => {
        let imgData = canvas.toDataURL("image/jpeg", 1.0);
        if (canvas.width >= canvas.height) {
          orientation = "l";
        } else {
          orientation = "p";
        }
        if (flag === 0) {
          pdf.deletePage(1);
          flag += 1;
        }
        //since it accept mm unit so it require to convert px to mm
        pdf.addPage(
          [canvas.height * 0.2645833333, canvas.width * 0.2645833333],
          orientation
        );
        pdf.addImage(imgData, "JPEG", 0, 0);
      });

      function fontProp(element, property) {
        return window
          .getComputedStyle(element, null)
          .getPropertyValue(property);
      }
      const promises = new Promise(async (resolve) => {
        for (let i = 0; i < eleOnPdf.length; i++) {
          let element = eleOnPdf[i];
          if (element) {
            let elementType = element.id.split("-"); //type check
            if (elementType[0] === "text" || elementType[0] === "copy") {
              //text
              //convert text to canvas
              let textCanvas = document
                .createElement("canvas")
                .getContext("2d");
              textCanvas.canvas.height = parseInt(
                element.style.height
              ).toString();
              textCanvas.canvas.width = parseInt(
                element.style.width
              ).toString();
              textCanvas.font =
              fontProp(element, "font-weight") + " " +
                fontProp(element, "font-size") +
                " " +
                fontProp(element, "font-family");
              textCanvas.textBaseline = "top";
              if (element.style.color)
                textCanvas.fillStyle = element.style.color;
              else textCanvas.fillStyle = "black";
              printAt(
                textCanvas,
                element.innerHTML,
                parseFloat(fontProp(element, "font-size")) / 10,
                parseFloat(fontProp(element, "font-size")) / 5,
                parseFloat(fontProp(element, "font-size")),
                parseFloat(element.style.width)
              );
              //function break line for canvas texting
              function printAt(context, text, x, y, lineHeight, fitWidth) {
                fitWidth = fitWidth || 0;
                if (fitWidth <= 0) {
                  context.fillText(text, x, y);
                  return;
                }
                for (let idx = 1; idx <= text.length; idx++) {
                  let str = text.substr(0, idx);
                  if (context.measureText(str).width > fitWidth) {
                    context.fillText(text.substr(0, idx - 1), x, y);
                    printAt(
                      context,
                      text.substr(idx - 1),
                      x,
                      y + lineHeight,
                      lineHeight,
                      fitWidth
                    );
                    return;
                  }
                }
                context.fillText(text, x, y);
              }
              //transform canvas to url binary64
              let xmlStr = textCanvas.canvas.toDataURL();
              //transform canvas url to svg xml
              const promisesSVG = new Promise(async (resolve) => {
                let trace = new potrace.Potrace();
                trace.loadImage(xmlStr, async function (err) {
                  if (err) throw err;
                  xmlStr = trace.getSVG();
                  let parser = new DOMParser();
                  let doc = parser.parseFromString(xmlStr, "text/html");
                  let svgPar = doc.body.childNodes[0];
                  svgPar.childNodes.forEach((child) => {
                    if (child.tagName === "path") {
                      if (element.style.color)
                        child.setAttribute("fill", element.style.color);
                      else child.setAttribute("fill", "black");
                    }
                  });
                  resolve(svgPar);
                });
              });
              //once finished draw svg to pdf
              await promisesSVG.then(async (svgelement) => {
                let currentY = parseInt(element.style.top, 10);
                let currentX = parseInt(element.style.left, 10);
                if (element.style.transform) {
                  currentY += parseFloat(getTranslateY(element));
                  currentX += parseFloat(getTranslateX(element));
                }
                let page = findPage(
                  currentY + parseFloat(element.offsetHeight) / 2
                );
                if (
                  document.querySelectorAll(".the-canvas")[page[0] - 1] &&
                  parseFloat(document.getElementById("pdfviewer").offsetWidth) >
                    parseFloat(
                      document.querySelectorAll(".the-canvas")[page[0] - 1]
                        .width
                    )
                ) {
                  currentX -=
                    document.getElementById("pdfviewer").offsetWidth / 2 -
                    document.querySelectorAll(".the-canvas")[page[0] - 1]
                      .width /
                      2;
                }
                pdf.setPage(page[0]);
                await pdf
                  .svg(svgelement, {
                    x: currentX * 0.2645833333,
                    y:
                      (page[1] - parseFloat(element.style.height, 10) / 2) *
                      0.2645833333,
                    width: parseFloat(element.style.width, 10) * 0.2645833333,
                    height: parseFloat(element.style.height, 10) * 0.2645833333,
                  })
                  .then(() => {});
              });
            } else if (
              elementType[0] === "cln" ||
              elementType[0] === "check" ||
              elementType[0] === "stamp"
            ) {
              //svg or image
              let currentY = parseInt(element.style.top, 10);
              let currentX = parseInt(element.style.left, 10);
              if (element.style.transform) {
                currentY += parseFloat(getTranslateY(element));
                currentX += parseFloat(getTranslateX(element));
              }
              let page = findPage(
                currentY + parseFloat(element.style.height, 10) / 2
              );
              pdf.setPage(page[0]);
              if (
                parseFloat(document.getElementById("pdfviewer").offsetWidth) >
                parseFloat(
                  document.querySelectorAll(".the-canvas")[page[0] - 1].width
                )
              ) {
                currentX -=
                  document.getElementById("pdfviewer").offsetWidth / 2 -
                  document.querySelectorAll(".the-canvas")[page[0] - 1].width /
                    2;
              }
              await pdf
                .svg(element, {
                  x: currentX * 0.2645833333,
                  y:
                    (page[1] - parseFloat(element.style.height, 10) / 2) *
                    0.2645833333,
                  width: parseFloat(element.style.width, 10) * 0.2645833333,
                  height: parseFloat(element.style.height, 10) * 0.2645833333,
                })
                .then(() => {});
            }
          }
        }
        //resolve after loops end
        resolve();
      });
      //flags
      promises.then(() => {
        let payload = {
          selectedFile: pdf.output("blob"),
          instance: instance,
          account: account,
          name: props.pdfName,
          id: props.pdfId,
        };
        UploadPDF(payload).then((res) => {
          let item = {
            key: res.id,
            fileDisplayName: res.file.displayName,
            fileExtension: "pdf",
          };
          if (props.pdfId) {
            DeletePDF(payload);
          }
          props.setPdfSaving(false);
          props.setOpeningFile(item);
          props.openFile(item);
          props.setPdfId("");
        });
      });
      function findPage(positionY) {
        let y = positionY;
        let i = 1;
        let isCount = true;
        let canvasArr = document.querySelectorAll(".the-canvas");
        canvasArr.forEach((element) => {
          if (y >= element.height + 5 && isCount) {
            y -= element.height + 5;
            i++;
          } else {
            isCount = false;
          }
        });
        return [i, y];
      }
      function getTranslateX(e) {
        let style = window.getComputedStyle(e);
        let matrix =
          style.transform || style.webkitTransform || style.mozTransform;
        let matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(", ");
        return matrixValues[4];
      }
      function getTranslateY(e) {
        let style = window.getComputedStyle(e);
        let matrix =
          style.transform || style.webkitTransform || style.mozTransform;
        let matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(", ");
        return matrixValues[5];
      }
    }
  }, [isExporting]);

  useEffect(() => {
    if (!imageSaving) {
      document.querySelector(".mobile-signside").style.display = "none";
      let imagediv = document.getElementById("imagediv");
      let sign = imagediv.lastElementChild;
      while (sign) {
        imagediv.removeChild(sign);
        sign = imagediv.lastElementChild;
      }
      document.querySelector(".mobile-miniside").style.display = "grid";
    }
  }, [imageSaving]);

  useEffect(() => {
    if (isConfirmSignDelete) {
      document.getElementById("confirm-delete").onclick = function () {
        setImageSaving(null);
        setConfirmSignDelete(false);
        let payload = {
          instance: instance,
          account: account,
        };
        DeleteFile(payload);
      };
      document.getElementById("not-delete").onclick = function () {
        setConfirmSignDelete(false);
      };
    }
  }, [isConfirmSignDelete]);

  useEffect(() => {
    if (isSignBox) {
      document.getElementById("exitsignbox").onclick = function () {
        setSignBox(false);
        setSignUploadSelected(false);
        setSignDrawSelected(false);
        setSignTypeSelected(false);
      };
      document.getElementById("upload-sign").onclick = function () {
        setSignUploadSelected(true);
        setSignDrawSelected(false);
        setSignTypeSelected(false);
      };
      document.getElementById("draw-sign").onclick = function () {
        setSignUploadSelected(false);
        setSignDrawSelected(true);
        setSignTypeSelected(false);
      };
      document.getElementById("type-sign").onclick = function () {
        setSignUploadSelected(false);
        setSignDrawSelected(false);
        setSignTypeSelected(true);
      };
    }
  }, [isSignBox]);

  function uploadSign(filename, datasvg) {
    let payload = {
      selectedFile: datasvg,
      instance: instance,
      account: account,
      name: filename,
    };
    UploadFile(payload);
    let parser = new DOMParser();
    let doc = parser.parseFromString(datasvg, "text/html");
    let svg = doc.body.childNodes[0];
    svg.style.height = "50";
    svg.style.width = "50";
    document.getElementById("imagediv").appendChild(svg);
    document.querySelector(".mobile-signside").style.display = "grid";
    document.getElementById("addSignature").style.display = "none";
    svg.classList.add("dup-drag-drop");
    setImageSaving(true);
    setSignBox(false);
  }

  useEffect(() => {
    if (signDrawSelected) {
      let canvas = document.getElementById("mobile-signature-pad");
      //resizeCanvas
      let ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext("2d").scale(ratio, ratio);
      if(signaturePad){
        signaturePad.clear();
        signaturePad.off();
      }
      let newSignaturePad = new SignaturePad(canvas, {
        //sign pad
        minWidth: penSize,
        maxWidth: penSize * 5,
        penColor: "rgb(0, 0, 0)",

      });
      document.getElementById("undo-pad").onclick = function () {
        //remove last line user draw
        let data = newSignaturePad.toData();
        data.pop();
        newSignaturePad.fromData(data);
      };
      document.getElementById("done-pad").onclick = function () {
        //save path to svg then upload
        let dataURI = newSignaturePad.toDataURL("image/svg+xml");
        let datasvg = atob(dataURI.replace(/data:image\/svg\+xml;base64,/, "")); //decode base64 to xml svg
        uploadSign("draw.svg", datasvg);
      };
      document.getElementById("clear-pad").onclick = function () {
        //clear sign pad
        newSignaturePad.clear();
      };
      setSignaturePad(newSignaturePad);
    }
  }, [signDrawSelected, penSize]);

  function selectElementContents(element) {
    let sel = window.getSelection();
    if (sel.anchorNode !== element) {
      let range = document.createRange();
      range.selectNodeContents(element);
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }

  useEffect(() => {
    if (signTypeSelected) {
      let signtextbox = document.getElementById("mobile-signtextbox");
      document.getElementById("done-type").onclick = function () {
        let textCanvas = document.createElement("canvas").getContext("2d");
        textCanvas.canvas.height = "300";
        textCanvas.canvas.width = "520";
        textCanvas.font =
          fontProp(signtextbox, "font-size") +
          " " +
          fontProp(signtextbox, "font-family");
        textCanvas.textBaseline = "middle";
        if (signtextbox.style.color)
          textCanvas.fillStyle = signtextbox.style.color;
        else textCanvas.fillStyle = "black";
        textCanvas.fillText(signtextbox.innerHTML, 10, 150);
        potracing(
          textCanvas.canvas.toDataURL(),
          "type.svg",
          textCanvas.fillStyle
        );
      };
      document.querySelectorAll(".colorPicker").forEach((color) => {
        color.onclick = function (event) {
          changeColor(event, signtextbox);
        };
      });
      document.getElementById("mobile-textboxfont").onchange = function () {
        signtextbox.style.fontFamily =
          document.getElementById("mobile-textboxfont").value;
      };
      signtextbox.onclick = function () {
        selectElementContents(signtextbox);
      };
      signtextbox.oninput = function () {
        //check overflow
        if (signtextbox.clientWidth < signtextbox.scrollWidth) {
          while (
            signtextbox.clientWidth < signtextbox.scrollWidth &&
            parseInt(fontProp(signtextbox, "font-size")) >= 12
          ) {
            signtextbox.style.fontSize =
              (parseInt(fontProp(signtextbox, "font-size")) - 2).toString() +
              "px";
          }
        } else {
          while (
            signtextbox.clientWidth >= signtextbox.scrollWidth &&
            parseInt(fontProp(signtextbox, "font-size")) <= 48
          ) {
            signtextbox.style.fontSize =
              (parseInt(fontProp(signtextbox, "font-size")) + 2).toString() +
              "px";
          }
        }
      };
    }
  }, [signTypeSelected]);

  //clone element
  function cloneEle(elementType ,
    {
      prototypeId = "initial",
      width = "initial",
      height = "initial",
      color = "black",
    } = {}) {
    let cln;
    document.querySelector(".mobile-sidenav").style.display = "none";
    if (elementType === "cln") {
      cln =
        prototypeId === "initial"
          ? document.querySelector(".dup-drag-drop").cloneNode(true)
          : document.getElementById(prototypeId).cloneNode(true);
      cln.setAttribute("id", "cln-" + signNum.toString());
      cln.style.width = width === "initial" ? "150px" : width;
      cln.style.height = height === "initial" ? "100px" : height;
      setSignNum(signNum + 1);
      cln.classList.remove("dup-drag-drop");
    } else if (elementType === "check") {
      cln =
        prototypeId === "initial"
          ? document.getElementById("checkMark").cloneNode(true)
          : document.getElementById(prototypeId).cloneNode(true);
      cln.setAttribute("id", "check-" + checkBoxNum.toString());
      setCheckBoxNum(checkBoxNum + 1);
      cln.style.width = width === "initial" ? "100px" : width;
      cln.style.height = height === "initial" ? "100px" : height;
      cln.contentEditable = "false";
    } else if (elementType === "stamp") {
      cln =
        prototypeId === "initial"
          ? document.querySelector(".stampimage").cloneNode(true)
          : document.getElementById(prototypeId).cloneNode(true);
      cln.setAttribute("id", "stamp-" + stampNum.toString());
      setStampNum(stampNum + 1);
      cln.style.width = width === "initial" ? "200px" : width;
      cln.style.height = height === "initial" ? "200px" : height;
    }

    if (elementType === "cln" || elementType === "stamp") {
      cln.childNodes.forEach((child) => {
        //if svg with path
        if (child.tagName == "path") {
          if (child.getAttribute("stroke")) {
            child.setAttribute("stroke", color);
          }
          if (child.getAttribute("fill")) {
            child.setAttribute("fill", color);
          }
        }
      });
    } else if (elementType === "check") {
      //if svg with attribute fill
      cln.childNodes[0].setAttribute("fill", color);
    }

    // cln.classList.add("resizable");
    cln.classList.add("nonedit-drag-drop");
    cln.classList.add("scalable");
    cln.style.position = "absolute";
    document.getElementById("pdfviewer").appendChild(cln);
    //set cloning position
    let frameHeight = document.getElementById("cardpdf").offsetHeight;
    let frameWidth = document.getElementById("cardpdf").offsetWidth;
    let currentX = document.getElementById("cardpdf").scrollLeft;
    let currentY = document.getElementById("cardpdf").scrollTop;
    let posX = currentX + frameWidth / 2 - 50;
    let posY = currentY + frameHeight / 2 - 50;
    cln.style.left = posX.toString() + "px";
    cln.style.top = posY.toString() + "px";
    cln.onclick = function () {
      cln.style.border = "2px solid black";
      setSignOptionBox(cln.id);
    };
  }

  function highlightTarget(shadow, elements) {
    elements.forEach((element) => {
      if (shadow) {
        shadow.style.boxShadow = "0px 0px 3px 2px grey";
      }

      element.addEventListener("mouseleave", function (e) {
        e.target.style.boxShadow = "0px 0px 0px 0px grey";
      });
    });
  }

  function shadowEle() {
    document.body.addEventListener("mouseover", function (e) {
      let shadow = e.target.closest(".mobile-miniside");
      highlightTarget(shadow, document.querySelectorAll(".mobile-miniside"));

      let shadow2 = e.target.closest(".mobile-signside");
      highlightTarget(shadow2, document.querySelectorAll(".mobile-signside"));

      let shadow3 = e.target.closest("#mobile-stampside");
      highlightTarget(shadow3, document.querySelectorAll("#mobile-stampside"));
    });
  }

  useEffect(() => {
    if (!imageSaving) {
      document.getElementById("addSignature").onclick = function () {
        setSignBox(true);
        setSignUploadSelected(true);
      };
    }

    if (imageSaving) {
      //click to copy sign to canvas
      document.getElementById("deleteSign").onclick = function () {
        setConfirmSignDelete(true);
      };

      let duplicator = document.getElementById("minigrid");
      duplicator.onclick = function () {
        cloneEle("cln");
      };
    }
    shadowEle();
  }, [imageSaving, signNum]);

  useEffect(() => {
    if (signOptionBox) {
      SignOptionBoxAppear();
    }
  }, [signOptionBox, isColoring]);

  useEffect(() => {
    document.getElementById("addCheckBox").onclick = function () {
      cloneEle("check");
    };
  }, [checkBoxNum]);

  useEffect(() => {
    if (isConfirmStampDelete) {
      document.getElementById("confirm-delete").onclick = function () {
        setStampSaving(false);
        setConfirmStampDelete(false);

        let payload = {
          instance: instance,
          account: account,
        };
        DeleteStamp(payload);
      };
      document.getElementById("not-delete").onclick = function () {
        setConfirmStampDelete(false);
      };
    }
  }, [isConfirmStampDelete]);

  useEffect(() => {
    if (!stampSaving) {
      document.getElementById("mobile-stampside").style.display = "none";
      let stampdiv = document.getElementById("stampdiv");
      let stamp = stampdiv.lastElementChild;
      while (stamp) {
        stampdiv.removeChild(stamp);
        stamp = stampdiv.lastElementChild;
      }
      document.getElementById("addStamp").style.display = "grid";
    }
  }, [stampSaving]);

  useEffect(() => {
    if (!stampSaving) {
      document.getElementById("addStamp").onclick = function () {
        setStampUploading(true);
      };
    }
    if (stampSaving) {
      //click to copy sign to canvas
      document.getElementById("deleteStamp").onclick = function () {
        setConfirmStampDelete(true);
      };

      let duplicator = document.getElementById("ministamp");
      duplicator.onclick = function () {
        cloneEle("stamp");
      };
    }
    shadowEle();
  }, [stampSaving, stampNum]);

  function uploadStamp(datapng) {
    document.getElementById("stamptitle").style.display = "none";
    document.getElementById("stamploading").style.display = "inline";
    document.getElementById("addStamp").style.pointerEvents = "none";
    const promisesSVG = new Promise(async (resolve) => {
      let trace = new potrace.Potrace();
      trace.loadImage(datapng, function (err) {
        if (err) throw err;
        let newpng = trace.getSVG();
        let parser = new DOMParser();
        let doc = parser.parseFromString(newpng, "text/html");
        let serializer = new XMLSerializer();
        let xmlStr = serializer.serializeToString(doc);
        let payload = {
          selectedFile: xmlStr,
          instance: instance,
          account: account,
          name: stampName,
        };
        UploadStamp(payload).then(() => {
          let svgPar = doc.body.childNodes[0];
          svgPar.childNodes.forEach((child) => {
            if (child.tagName === "path") {
              child.setAttribute("fill", "black");
            }
          });
          resolve(svgPar);
        });
      });
    });
    promisesSVG.then((svgPar) => {
      document.getElementById("stampdiv").appendChild(svgPar);
      svgPar.style.height = "40px";
      svgPar.style.width = "40px";
      document.getElementById("mobile-stampside").style.display = "grid";
      document.getElementById("addStamp").style.display = "none";
      document.getElementById("stamptitle").style.display = "inline";
      document.getElementById("stamploading").style.display = "none";
      document.getElementById("addStamp").style.pointerEvents = "auto";
      svgPar.classList.add("stampimage");
      setStampSaving(true);
    });
  }

  // function getRoundedCanvas(sourceCanvas) {
  //   let canvas = document.createElement("canvas");
  //   let context = canvas.getContext("2d");
  //   let width = sourceCanvas.width;
  //   let height = sourceCanvas.height;

  //   canvas.width = width;
  //   canvas.height = height;
  //   context.imageSmoothingEnabled = true;
  //   context.drawImage(sourceCanvas, 0, 0, width, height);
  //   context.globalCompositeOperation = "destination-in";
  //   context.beginPath();
  //   context.arc(
  //     width / 2,
  //     height / 2,
  //     Math.min(width, height) / 2,
  //     0,
  //     2 * Math.PI,
  //     true
  //   );
  //   context.fill();
  //   return canvas;
  // }
  function createCropPad(file) {
    document.getElementById("crop-pad").style.display = "block";
    document.getElementById("mobile-dropimage").style.display = "none";
    let image = document.getElementById("image");
    image.src = file;
    let button = document.getElementById("mobile-apply-crop");
    let croppable = false;
    let cropper = new Cropper(image, {
      // aspectRatio: 1, //set to 1 will get square crop, not set for free ratio
      viewMode: 1,
      ready: function () {
        croppable = true;
      },
    });
    button.onclick = function () {
      if (!croppable) {
        return;
      }
      // Crop
      let croppedCanvas = cropper.getCroppedCanvas();
      // Round
      // let roundedCanvas = getRoundedCanvas(croppedCanvas);
      // Save
      // let dataURI = roundedCanvas.toDataURL();
      let dataURI = croppedCanvas.toDataURL();
      uploadStamp(dataURI);
      setStampName("");
      setStampCropping(false);
      setStampUploading(false);
    };
  }

  useEffect(() => {
    if (stampCropping) {
      createCropPad(stampCropping);
    }
  }, [stampCropping]);

  function SignOptionBoxAppear() {
    let sob = document.getElementById("signOptionBox");
    let colorb = document.getElementById("colorBox");
    let cln = document.getElementById(signOptionBox);

    const delta = 6;
    let startX;
    let startY;

    movingCln();

    cln.addEventListener("mousedown", function (event) {
      if (!isColoring && sob) {
        startX = event.pageX;
        startY = event.pageY;
        sob.style.display = "none";
      } else if (isColoring && colorb) {
        startX = event.pageX;
        startY = event.pageY;
        colorb.style.display = "none";
      }
    });

    cln.addEventListener("mouseup", function (event) {
      const diffX = Math.abs(event.pageX - startX);
      const diffY = Math.abs(event.pageY - startY);
      if (diffX < delta && diffY < delta) {
        // Click!
        movingCln();
      } else {
        // Drag
        movingCln();
      }
    });

    function movingCln() {
      if (sob) {
        if (!isColoring) {
          sob.style.display = "flex";
          if(document.getElementById("pdfviewer").getBoundingClientRect().top >= cln.getBoundingClientRect().top - 70){
            sob.style.top = (parseFloat(cln.style.top) + parseFloat(cln.style.height)).toString() + "px";
          }
          else{
            sob.style.top = (parseFloat(cln.style.top) - 70).toString() + "px";
          }
          sob.style.left = cln.style.left;
          sob.style.transform = cln.style.transform;
        } else {
          colorb.style.display = "flex";
          if(document.getElementById("pdfviewer").getBoundingClientRect().top >= cln.getBoundingClientRect().top - 70){
            colorb.style.top = (parseFloat(cln.style.top) + parseFloat(cln.style.height)).toString() + "px";
          }
          else{
            colorb.style.top = (parseFloat(cln.style.top) - 70).toString() + "px";
          }
          colorb.style.left = cln.style.left;
          colorb.style.transform = cln.style.transform;
        }
      }
    }

    function deleteCln() {
      cln.remove();
      setSignOptionBox(false);
      sob.style.display = "none";
    }

    function duplicateSVG() {
      let clnType = cln.id.split("-")[0];
      let color = "black";
      if (clnType === "cln" || clnType === "stamp") {
        cln.childNodes.forEach((child) => {
          //if svg with path
          if (child.tagName == "path") {
            if (child.getAttribute("stroke")) {
              color = child.getAttribute("stroke");
            }
            if (child.getAttribute("fill")) {
              color = child.getAttribute("fill");
            }
          }
        });
      } else if (clnType === "check") {
        //if svg with attribute fill
        color = cln.childNodes[0].getAttribute("fill");
      }
      cloneEle(clnType, {
        prototypeId: cln.id,
        height: cln.style.height,
        width: cln.style.width,
        color: color
      });
      cln.style.border = "";
      setSignOptionBox(false);
    }

    if (!isColoring && sob) {
      document.querySelector(".deleteChecking").onclick = deleteCln;
      document.querySelector(".duplicateSVG").onclick = duplicateSVG;
      document.querySelector(".changeColor").onclick = changingBoxAppear;
    } else if (isColoring && colorb) {
      document.querySelector(".back").onclick = backToOptionBox;
      let colorPickers = document.querySelectorAll(".colorPicker");
      colorPickers.forEach((element) => {
        element.onclick = function (event) {
          changeColor(event, cln);
        };
      });
    }
  }

  function textOptionBoxAppear() {
    let tob = document.getElementById("textOptionBox");
    let cln = document.getElementById(textOptionBox);
    let colorb = document.getElementById("colorBox");

    const delta = 6;
    let startX;
    let startY;

    movingCln(tob, cln);

    cln.addEventListener("mousedown", function (event) {
      startX = event.pageX;
      startY = event.pageY;
      if (tob) tob.style.display = "none";
    });

    cln.addEventListener("mouseup", function (event) {
        movingCln(tob, cln);
    });

    function deleteCln() {
      cln.remove();
      setTextOptionBox(false);
      tob.style.display = "none";
    }
    function fontIncrease() {
      let fontsize = parseFloat(cln.style.fontSize, 10);
      if (cln.clientHeight < cln.scrollHeight) {
        cln.style.height = (cln.scrollHeight * 1.1).toString() + "px";
      }
      cln.style.fontSize = (fontsize + 2).toString() + "px";
      cln.style.width = (parseFloat(cln.offsetWidth) + 4).toString() + "px";
    }
    function fontDecrease() {
      let fontsize = parseFloat(cln.style.fontSize, 10);
      if (fontsize >= 12) {
        cln.style.fontSize = (fontsize - 2).toString() + "px";
      } else if (fontsize > 10) {
        cln.style.fontSize = 10;
      }
    }
    function duplicateText() {
      let clnType = cln.id.split("-")[0];
      creatingEle(clnType, {
        text: cln.innerHTML,
        height: cln.style.height,
        width: cln.style.width,
        fontSize: fontProp(cln, "font-size"),
        fontFamily: fontProp(cln, "font-family"),
        color: cln.style.color
      });
      cln.style.border = "";
      setTextOptionBox(false);
    }

    if (!isColoring && tob) {
      document.querySelector(".deleteTexting").onclick = deleteCln;
      document.querySelector(".fontIncrease").onclick = fontIncrease;
      document.querySelector(".fontDecrease").onclick = fontDecrease;
      document.querySelector(".duplicateText").onclick = duplicateText;
      document.querySelector(".changeColor").onclick = changingBoxAppear;
    } else if (isColoring && colorb) {
      document.querySelector(".back").onclick = backToOptionBox;
      let colorPickers = document.querySelectorAll(".colorPicker");
      colorPickers.forEach((element) => {
        element.onclick = function (event) {
          changeColor(event, cln);
        };
      });
    }
  }

  function movingCln(optionBox, element) {
    let colorb = document.getElementById("colorBox");
    let font = document.querySelector(".font");
    if (!isColoring && font) {
      optionBox.style.display = "block";
      if(document.getElementById("pdfviewer").getBoundingClientRect().top >= element.getBoundingClientRect().top - 90){
        optionBox.style.top = (parseFloat(element.style.top) + parseFloat(element.style.height)).toString() + "px";
      }
      else{
        optionBox.style.top = (parseFloat(element.style.top) - 90).toString() + "px";
      }
      optionBox.style.left = element.style.left;
      optionBox.style.transform = element.style.transform;
      if (fontProp(element, "font-family") === "Prompt, sans-serif") {
        font.selectedIndex = "0";
      } else if (fontProp(element, "font-family") === "Sarabun, sans-serif") {
        font.selectedIndex = "1";
      } else if (
        fontProp(element, "font-family") === '"Source Serif Pro", serif'
      ) {
        font.selectedIndex = "2";
      }
      font.onchange = function () {
        element.style.fontFamily = font.value;
      };
    } else if (isColoring && colorb) {
      colorb.style.display = "flex";
      if(document.getElementById("pdfviewer").getBoundingClientRect().top >= element.getBoundingClientRect().top - 70){
        colorb.style.top = (parseFloat(element.style.top) + parseFloat(element.style.height)).toString() + "px";
      }
      else{
        colorb.style.top = (parseFloat(element.style.top) - 70).toString() + "px";
      }
      colorb.style.left = element.style.left;
      colorb.style.transform = element.style.transform;
    }
  }
  function changingBoxAppear() {
    setColoring(true);
  }
  function backToOptionBox() {
    setColoring(false);
  }
  function fontProp(element, property) {
    return window.getComputedStyle(element, null).getPropertyValue(property);
  }
  function changeColor(event, element) {
    let color = event.target.getAttribute("fill")
      ? event.target.getAttribute("fill")
      : false;
    let elementType = element.id.split("-")[0];
    if (color) {
      if (elementType === "cln" || elementType === "stamp") {
        element.childNodes.forEach((child) => {
          if (child.tagName === "path") {
            if (child.getAttribute("stroke")) {
              child.setAttribute("stroke", color);
            }
            if (child.getAttribute("fill")) {
              child.setAttribute("fill", color);
            }
          }
        });
      } else if (elementType === "check") {
        element.childNodes[0].setAttribute("fill", color);
      } else {
        element.style.color = color;
      }
    }
  }

  function creatingEle(elementType, {text = "initial", height = "50px", width = "initial", fontSize = "30px", fontFamily = "Sarabun, sans-serif", color = "black"} = {}) {
    let newdiv = document.createElement("div");
    document.querySelector(".mobile-sidenav").style.display = "none";
    //text and true certificated copy stamp attribute here
    if (elementType === "text") {
      newdiv.style.width = width === "initial" ? "120px" : width;
      newdiv.innerHTML = text === "initial" ? t("Text") : text;
      newdiv.contentEditable = "true";
      newdiv.suppressContentEditableWarning = true;
      newdiv.setAttribute("id", "text-" + textNum.toString());
      setTextNum(textNum + 1);
      newdiv.oninput = function () {
        //check overflow
        newdiv.style.height = newdiv.offsetHeight;
        while (
          newdiv.clientWidth < newdiv.scrollWidth ||
          newdiv.clientHeight < newdiv.scrollHeight
        ) {
          newdiv.style.height =
            (
              (parseFloat(newdiv.style.fontSize) / 3) * 5 +
              parseFloat(newdiv.offsetHeight)
            ).toString() + "px";
        }
      };
      newdiv.onkeydown = function (e) {
        if( e.key == "Enter" ) {
          e.preventDefault();
        }
      };
    } else if (elementType === "copy") {
      newdiv.style.width = width === "initial" ? "250px" : width;
      newdiv.innerHTML = text === "initial" ? t("Certified True Copy") : text;
      newdiv.style.fontWeight = "bold";
      newdiv.setAttribute("id", "copy-" + trueCopyNum.toString());
      setTrueCopyNum(trueCopyNum + 1);
    }
    newdiv.style.height = height; //set element style
    newdiv.style.fontSize = fontSize;
    newdiv.style.fontFamily = fontFamily;
    newdiv.style.color = color;
    newdiv.style.textAlign = "left";
    newdiv.addEventListener("mouseup", function () {
      if (newdiv.clientHeight < newdiv.scrollHeight) {
        newdiv.style.height = (newdiv.scrollHeight * 1.1).toString() + "px";
      }
    });
    newdiv.classList.add("scalable");
    newdiv.classList.add("nonedit-drag-drop");
    newdiv.onclick = function () {
      setTextOptionBox(newdiv.id);
      // if(!newdiv.classList.contains("resizable"))
      //   newdiv.classList.add("resizable");
    };
    //set cloning position
    let frameHeight = parseInt(
      document.getElementById("cardpdf").offsetHeight
      // document.getElementById("cardpdf").style.height,
      // 10
    );
    let frameWidth = parseInt(
      document.getElementById("cardpdf").offsetWidth,
      10
    );
    let currentX = document.getElementById("cardpdf").scrollLeft;
    let currentY = document.getElementById("cardpdf").scrollTop;
    let posX = currentX + frameWidth / 2 - newdiv.offsetWidth / 2;
    let posY = currentY + frameHeight / 2 - newdiv.offsetHeight / 2;
    newdiv.style.background = "transparent";
    newdiv.style.position = "absolute";
    newdiv.style.left = posX.toString() + "px";
    newdiv.style.top = posY.toString() + "px";
    document.getElementById("pdfviewer").appendChild(newdiv);
    if (elementType === "text") {
      let range = document.createRange();
      let sel = window.getSelection();
      range.setStart(newdiv.lastChild, newdiv.lastChild.length);
      range.collapse(true);
      sel.removeAllRanges();
      sel.addRange(range);
      newdiv.focus();
    }
  }

  useEffect(() => {
    document.getElementById("addText").onclick = function () {
      creatingEle("text");
    };

    document.getElementById("addCopy").onclick = function () {
      creatingEle("copy");
    };

    if (textOptionBox) {
      textOptionBoxAppear();
    }
  }, [textOptionBox, isColoring, textNum, trueCopyNum]);

  useEffect(() => {
    document.body.onclick = function (e) {
      if (e.target.closest(".scalable")) {
        document.querySelectorAll(".scalable").forEach((element) => {
          element.style.border = "";
          if (element.id.split("-")[0] === "text") {
            element.classList.add("drag-drop");
          } else {
            element.classList.add("nonedit-drag-drop");
          }
          element.classList.remove("resizable");
        });
        e.target.style.border = "2px solid black";
        e.target.classList.add("resizable");
        e.target.classList.remove("drag-drop");
        e.target.classList.remove("nonedit-drag-drop");
        let elementType = e.target.id.split("-")[0];
        if (elementType === "text" || elementType === "copy") {
          if (!setTextOptionBox) {
          }
          setTextOptionBox(e.target.id);
          setSignOptionBox(false);
        } else if (
          elementType === "cln" ||
          elementType === "check" ||
          elementType === "stamp"
        ) {
          setSignOptionBox(e.target.id);
          setTextOptionBox(false);
        }
        setColoring(false);
      } else if (e.target.closest("#ob")) {
        // do nothing
      } else {
        if (textOptionBox && document.getElementById(textOptionBox)) {
          if (document.getElementById(textOptionBox).innerHTML === "") {
            document.getElementById(textOptionBox).remove();
          }
        }
        setSignOptionBox(false);
        setTextOptionBox(false);
        setColoring(false);
        document.querySelectorAll(".scalable").forEach((element) => {
          element.style.border = "";
          if (element.id.split("-")[0] === "text") {
            element.classList.add("drag-drop");
          } else {
            element.classList.add("nonedit-drag-drop");
          }
          element.classList.remove("resizable");
        });
      }
    };
  }, [signOptionBox, textOptionBox]);

  return (
    <div style={{ overflow: "visible", position: "absolute", right: 0 }}>
      <div>
        <div>
          {isSignBox ? (
            <div className="popupbox">
              <div className="transparentblur">
                <span className="mobile-largebox">
                  <div className="mobile-menu">
                    <div className="mobile-minibox" id="upload-sign">
                      <FontIcon
                        aria-label="Upload"
                        iconName="Upload"
                        className={iconMediumClass}
                      />
                    </div>
                    <div className="mobile-minibox" id="draw-sign">
                      <FontIcon
                        aria-label="PenWorkspace"
                        iconName="PenWorkspace"
                        className={iconMediumClass}
                      />
                    </div>
                    <div className="mobile-minibox" id="type-sign">
                      <FontIcon
                        aria-label="PlainText"
                        iconName="PlainText"
                        className={iconMediumClass}
                      />
                    </div>
                    <div className="mobile-minibox" id="exitsignbox">
                      <FontIcon
                        aria-label="ChromeClose"
                        iconName="ChromeClose"
                        className={iconMediumClass}
                      />
                    </div>
                  </div>
                  {signUploadSelected ? (
                    <div id="mobile-dropimage">
                      <div className="mobile-dropzoneimg" {...getRootProps()}>
                        <input
                          type="image"
                          accept="image/*"
                          {...getInputProps()}
                        />
                        <div className="img">
                          <i
                            className="fas fa-files-medical"
                            style={{
                              fontSize: "80px",
                              color: "rgba(45, 45, 83, 0.808)",
                            }}
                          ></i>
                        </div>
                        {isDragActive ? (
                          <p className="mobile-dropzone-text">
                            {t("Drop the file here ...")}
                          </p>
                        ) : (
                          <p className="mobile-dropzone-text">
                            {t("Drag or Click here to upload signature file")}
                          </p>
                        )}
                        <button className="up-btn">{t("Upload File")}</button>
                      </div>
                    </div>
                  ) : signDrawSelected ? (
                    <div className="mobile-drawzone">
                      <div>
                        <canvas id="mobile-signature-pad"></canvas>
                        <Slider
                          label={t("pen size")}
                          min={0.1}
                          max={1.5}
                          step={0.1}
                          value={penSize}
                          onChange={(value) => {
                            setPenSize(value);
                          }}
                          showValue
                          styles={{ valueLabel: { textAlign: "right" } }}
                          className="mobile-signature-pad-slider"
                        />
                      </div>
                      <div className="mobile-signature-pad-buttons">
                        <DefaultButton
                          id="undo-pad"
                          className="noselect mobile-signature-pad-button"
                        >
                          <FontIcon
                            aria-label="Back"
                            iconName="Back"
                            className={iconMediumClass}
                          />
                        </DefaultButton>
                        <div>
                          <DefaultButton
                            className="noselect mobile-signature-pad-button"
                            id="done-pad"
                          >
                            <FontIcon
                              aria-label="CheckMark"
                              iconName="CheckMark"
                              className={iconMediumClass}
                            />
                          </DefaultButton>
                          <DefaultButton
                            className="noselect mobile-signature-pad-button"
                            id="clear-pad"
                          >
                            <FontIcon
                              aria-label="Delete"
                              iconName="Delete"
                              className={iconMediumClass}
                            />
                          </DefaultButton>
                        </div>
                      </div>
                    </div>
                  ) : signTypeSelected ? (
                    <div className="mobile-typebox">
                      <div className="mobile-textbox-pad-buttons">
                        <div
                          className="mobile-textbox-color-pad"
                          contentEditable="false"
                        >
                          <span className="colorPicker" id="ob">
                            <svg height="50" width="50" id="ob">
                              <circle
                                id="ob"
                                cx="25"
                                cy="25"
                                r="20"
                                stroke="black"
                                stroke-width="3"
                                fill="black"
                              />
                            </svg>
                          </span>
                          <span className="colorPicker" id="ob">
                            <svg height="50" width="50" id="ob">
                              <circle
                                id="ob"
                                cx="25"
                                cy="25"
                                r="20"
                                stroke="black"
                                stroke-width="3"
                                fill="red"
                              />
                            </svg>
                          </span>
                          <span className="colorPicker" id="ob">
                            <svg height="50" width="50" id="ob">
                              <circle
                                id="ob"
                                cx="25"
                                cy="25"
                                r="20"
                                stroke="black"
                                stroke-width="3"
                                fill="#2658b2"
                              />
                            </svg>
                          </span>
                        </div>
                        <div>
                          <select id="mobile-textboxfont">
                            <option
                              value="CSChatThaiUI, sans-serif"
                              style={{
                                fontFamily: "CSChatThaiUI, sans-serif",
                              }}
                            >
                              Signature ลายมือชื่อ
                            </option>
                            <option
                              value="Sarabun, sans-serif"
                              style={{ fontFamily: "Sarabun, sans-serif" }}
                            >
                              Signature ลายมือชื่อ
                            </option>
                            <option
                              value="MilkTea"
                              style={{ fontFamily: "MilkTea" }}
                            >
                              Signature ลายมือชื่อ
                            </option>
                            <option
                              value="Akhanake"
                              style={{ fontFamily: "Akhanake" }}
                            >
                              Signature ลายมือชื่อ
                            </option>
                            <option
                              value="Charm, cursive"
                              style={{ fontFamily: "Charm, cursive" }}
                            >
                              Signature ลายมือชื่อ
                            </option>
                            <option
                              value="Charmonman, cursive"
                              style={{ fontFamily: "Charmonman, cursive" }}
                            >
                              Signature ลายมือชื่อ
                            </option>
                            <option
                              value="Tangerine, cursive"
                              style={{ fontFamily: "Tangerine, cursive" }}
                            >
                              Signature ลายมือชื่อ
                            </option>
                            <option
                              value="MonteCarlo, cursive"
                              style={{ fontFamily: "MonteCarlo, cursive" }}
                            >
                              Signature ลายมือชื่อ
                            </option>
                            <option
                              value="Courgette, cursive"
                              style={{ fontFamily: "Courgette, cursive" }}
                            >
                              Signature ลายมือชื่อ
                            </option>
                          </select>
                        </div>
                      </div>
                      <div
                        id="mobile-signtextbox"
                        contentEditable="true"
                        suppressContentEditableWarning="true"
                      >
                        {t("Type Here")}
                      </div>
                      <div className="mobile-textbox-finished-pad-button">
                        <DefaultButton
                          className="noselect"
                          id="done-type"
                          style={{ height: "60px", width: "60px" }}
                        >
                          <FontIcon
                            aria-label="CheckMark"
                            iconName="CheckMark"
                            className={iconClass}
                          />
                        </DefaultButton>
                      </div>
                    </div>
                  ) : null}
                </span>
                <div></div>
              </div>
            </div>
          ) : null}
          {isConfirmSignDelete || isConfirmStampDelete ? (
            <div className="popupbox">
              <div className="transparentblur">
                <div className="mobile-largebox">
                  <div className="menutext">{t("Confirm to delete?")}</div>
                  <div className="break"></div>
                  <div className="menubutton" id="confirm-delete">
                    {t("Yes")}
                  </div>
                  <div className="menubutton" id="not-delete">
                    {t("No")}
                  </div>
                </div>
              </div>
            </div>
          ) : null}
          {stampUploading ? (
            <div className="popupbox">
              <div className="transparentblur">
                <span className="mobile-largebox">
                  <div>
                    <div id="close-stamp-tab">
                      <DefaultButton
                        type="button"
                        style={{
                          cursor: "pointer",
                          width: "50px",
                          height: "50px",
                          padding: "5px 0px",
                        }}
                        onClick={function () {
                          setStampUploading(false);
                          setStampName("");
                          setStampCropping(false);
                        }}
                      >
                        <FontIcon
                          aria-label="Cancel"
                          iconName="Cancel"
                          className={iconClass}
                        />
                      </DefaultButton>
                    </div>
                    <div id="crop-pad" style={{ display: "none" }}>
                      <div class="container crop-pad">
                        <img id="image" alt="Picture" />
                        <div className="crop-menu">
                          <center>
                            <PrimaryButton
                              id="mobile-apply-crop"
                              type="button"
                              style={{
                                cursor: "pointer",
                              }}
                            >
                              {t("Apply")}
                            </PrimaryButton>
                          </center>
                        </div>
                      </div>
                    </div>
                    <div id="mobile-dropimage">
                      <div className="mobile-dropzoneimg" {...getRootProps()}>
                        <input
                          type="image"
                          accept="image/*"
                          {...getInputProps()}
                        />
                        <div className="img">
                          <i
                            className="fas fa-files-medical"
                            style={{
                              fontSize: "80px",
                              color: "rgba(45, 45, 83, 0.808)",
                            }}
                          ></i>
                        </div>
                        {isDragActive ? (
                          <p className="mobile-dropzone-text">
                            {t("Drop the file here ...")}
                          </p>
                        ) : (
                          <p className="mobile-dropzone-text">
                            {t("Drag or Click here to upload stamp file")}
                          </p>
                        )}
                        <button className="up-btn">{t("Upload File")}</button>
                      </div>
                    </div>
                  </div>
                </span>
              </div>
            </div>
          ) : null}
          <div className="popupbox" id="exporting" style={{ display: "none" }}>
            <div className="mobile-exportingbg">
              <Stack horizontal horizontalAlign="center">
                <div className="mobile-export-loading-center">
                  <Spinner
                    label={t("Exporting...")}
                    labelPosition="down"
                    ariaLive="assertive"
                    styles={spinnerStylesLarge}
                  />
                </div>
              </Stack>
            </div>
          </div>
          {/* sidenav */}
          <div id="mobile-sidenav-show" className="mobile-sidenav-show">
            <FontIcon
              aria-label="OpenInNewWindow"
              iconName="OpenInNewWindow"
              className={iconClass}
            />
          </div>
          <div className="mobile-sidenav">
            <div>
              <div className="mobile-miniside-menu">
                <PrimaryButton
                  id="mobile-export"
                  type="button"
                  className="mobile-export"
                >
                  <span>{t("Export PDF")}</span>
                </PrimaryButton>
                <PrimaryButton
                  id="mobile-sidenav-hide"
                  type="button"
                  className="mobile-sidenav-hide"
                >
                  <span>{t("Hide")}</span>
                </PrimaryButton>
              </div>
              <div className="mobile-signside" style={{ display: "none" }}>
                <svg viewBox="0 0 16 16">
                  <path d="M6.66667 1.33337H4V4.00004H6.66667V1.33337ZM12 1.33337H9.33333V4.00004H12V1.33337ZM12 6.66671H9.33333V9.33337H12V6.66671ZM9.33333 12H12V14.6667H9.33333V12ZM4 6.66671H6.66667V9.33337H4V6.66671ZM6.66667 12H4V14.6667H6.66667V12Z"></path>
                </svg>
                <div className="minigrid" id="minigrid">
                  <div id="imagediv"></div>
                </div>
                <div id="deleteSign">
                  <span className="add">{t("Delete")}</span>
                </div>
              </div>
              <div className="mobile-miniside row" id="addSignature">
                <div>
                  <svg viewBox="0 0 16 16">
                    <path d="M6.66667 1.33337H4V4.00004H6.66667V1.33337ZM12 1.33337H9.33333V4.00004H12V1.33337ZM12 6.66671H9.33333V9.33337H12V6.66671ZM9.33333 12H12V14.6667H9.33333V12ZM4 6.66671H6.66667V9.33337H4V6.66671ZM6.66667 12H4V14.6667H6.66667V12Z"></path>
                  </svg>
                </div>
                <div>
                  <svg viewBox="0 0 24 24" width="40px" height="40px">
                    <path
                      fill="currentColor"
                      d="M16.5854 4.1259C17.2033 6.65657 16.0211 8.61635 13.1428 10.0076C12.942 10.8207 12.7336 11.7073 12.5177 12.6672C12.8096 12.5258 13.1195 12.3851 13.451 12.2421C13.8836 12.0555 14.1029 11.9655 15.1602 11.5367C16.5934 10.9554 17.4697 10.9456 17.3808 11.9599C17.3435 12.3851 17.0733 12.8111 16.3583 13.7605C16.3294 13.7989 16.3294 13.7989 16.3004 13.8373C15.9909 14.2473 15.9936 14.2438 15.8931 14.381C15.6456 14.7187 15.4015 15.0481 15.1604 15.3696C15.5823 15.1226 16.077 14.8257 16.6439 14.4792C18.001 13.6497 19.0296 13.2287 19.7805 13.2287C20.7216 13.2287 21.2275 13.8731 21.2045 14.9168L20.2048 14.8949C20.2163 14.3691 20.1061 14.2287 19.7805 14.2287C19.2648 14.2287 18.3761 14.5924 17.1654 15.3325C15.8712 16.1235 14.9444 16.6618 14.3778 16.9507C14.0535 17.1161 13.8396 17.2063 13.6762 17.2325C13.3734 17.2812 13.0407 17.1653 13.0262 16.7309C13.0199 16.5428 13.0835 16.4284 13.1985 16.2867C13.8039 15.5137 14.4333 14.6815 15.0864 13.79C15.1816 13.66 15.1879 13.6514 15.4241 13.3383L15.5595 13.1589C15.8668 12.7509 16.0854 12.4397 16.2201 12.2204C16.0408 12.2712 15.812 12.3514 15.5361 12.4634C14.4872 12.8888 14.2701 12.9779 13.8471 13.1603C13.2375 13.4233 12.7099 13.6754 12.237 13.9374C12.2177 14.0259 12.1984 14.1149 12.1791 14.2044C11.8171 15.6821 11.4369 16.9473 11.033 18.0006L21 18V19L10.6135 18.9996C9.862 20.6248 9.02892 21.5744 8.0829 21.8515C7.36828 22.0608 6.78327 21.9004 6.4975 21.3538C6.28021 20.9382 6.28523 20.3689 6.45651 19.6788C6.51033 19.4619 6.58071 19.2345 6.66552 19.0005L3 19V18L7.0962 17.9996C7.48393 17.2151 7.99001 16.4211 8.544 15.7516C8.70958 15.5515 8.8756 15.362 9.04283 15.1819C9.763 14.4066 10.4799 13.8193 11.3545 13.2923C11.5748 12.2894 11.7879 11.3584 11.9939 10.499C10.924 10.9046 9.67695 11.2505 8.2562 11.5366L8.05877 10.5563C9.75356 10.215 11.1601 9.79957 12.2859 9.31021C12.9021 6.86572 13.4511 5.10509 13.9365 4.02105C14.8551 1.96933 16.0622 1.98285 16.5854 4.1259ZM9.50182 18.9999L7.73823 19.0006C7.60398 19.3232 7.49791 19.6342 7.42706 19.9196C7.30926 20.3943 7.30619 20.7422 7.38368 20.8905C7.41837 20.9568 7.50179 20.9797 7.80179 20.8918C8.36971 20.7254 8.94292 20.0937 9.50182 18.9999ZM11.0145 14.7287C10.5787 15.0606 10.1781 15.4291 9.77552 15.8625C9.62143 16.0284 9.46797 16.2036 9.31441 16.3892C8.91346 16.8737 8.53873 17.4331 8.22509 17.9992L9.95583 18.0012C10.3192 17.1116 10.674 16.0204 11.0145 14.7287ZM6.33333 12L7 12.6667L5.66667 14L7 15.3333L6.33333 16L5 14.6667L3.66667 16L3 15.3333L4.33333 14L3 12.6667L3.66667 12L5 13.3333L6.33333 12ZM14.8492 4.4297C14.4466 5.32881 13.9878 6.75455 13.4746 8.70448C15.3536 7.57299 16.0442 6.12534 15.614 4.36308C15.3301 3.20032 15.3993 3.20109 14.8492 4.4297Z"
                    ></path>
                  </svg>
                </div>
                <div id="signtitle" style={{ display: "inline" }}>
                  {t("Your Signature")}
                </div>
                <div id="signloading" style={{ display: "none" }}>
                  <Stack>
                    <div>
                      <Spinner
                        label={t("loading sign...")}
                        ariaLive="assertive"
                        labelPosition="left"
                        styles={spinnerStyles}
                      />
                    </div>
                  </Stack>
                </div>
                <div className="add">{t("Add")}</div>
              </div>
              <div className="mobile-miniside" id="addText">
                <svg viewBox="0 0 16 16">
                  <path d="M6.66667 1.33337H4V4.00004H6.66667V1.33337ZM12 1.33337H9.33333V4.00004H12V1.33337ZM12 6.66671H9.33333V9.33337H12V6.66671ZM9.33333 12H12V14.6667H9.33333V12ZM4 6.66671H6.66667V9.33337H4V6.66671ZM6.66667 12H4V14.6667H6.66667V12Z"></path>
                </svg>
                <svg
                  viewBox="0 0 24 24"
                  width="40px"
                  height="40px"
                  fill="currentColor"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="icon"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M12 5V19H16V20H7V19H11V5H5.00034L5 8H4V4H19V8H18L18.0005 5H12Z"
                  ></path>
                </svg>
                <span>{t("Text")}</span>
                <span className="add">{t("Add")}</span>
              </div>
              <div className="mobile-miniside" id="addCopy">
                <svg viewBox="0 0 16 16">
                  <path d="M6.66667 1.33337H4V4.00004H6.66667V1.33337ZM12 1.33337H9.33333V4.00004H12V1.33337ZM12 6.66671H9.33333V9.33337H12V6.66671ZM9.33333 12H12V14.6667H9.33333V12ZM4 6.66671H6.66667V9.33337H4V6.66671ZM6.66667 12H4V14.6667H6.66667V12Z"></path>
                </svg>
                <svg
                  version="1.0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="40px"
                  height="40px"
                  viewBox="0 0 180 180"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <g
                    transform="translate(15, 160) scale(0.1,-0.1)"
                    fill="#000000"
                    stroke="none"
                  >
                    <path
                      d="M680 1475 c-98 -32 -169 -122 -177 -228 -6 -67 1 -96 43 -197 19 -47
                          28 -88 32 -150 6 -122 4 -123 -192 -130 -168 -6 -201 -17 -263 -82 -59 -61
                          -73 -108 -73 -245 l0 -123 715 0 715 0 0 108 c0 144 -17 200 -79 262 -66 66
                          -114 80 -268 80 -148 0 -178 11 -189 66 -10 54 3 140 32 208 52 124 56 139 50
                          199 -18 173 -183 285 -346 232z"
                    />
                    <path d="M140 140 l0 -90 625 0 625 0 0 90 0 90 -625 0 -625 0 0 -90z" />
                  </g>
                </svg>
                <span>{t("Certified True Copy")}</span>
                <span className="add">{t("Add")}</span>
              </div>
              <div className="mobile-miniside" id="addCheckBox">
                <svg viewBox="0 0 16 16">
                  <path d="M6.66667 1.33337H4V4.00004H6.66667V1.33337ZM12 1.33337H9.33333V4.00004H12V1.33337ZM12 6.66671H9.33333V9.33337H12V6.66671ZM9.33333 12H12V14.6667H9.33333V12ZM4 6.66671H6.66667V9.33337H4V6.66671ZM6.66667 12H4V14.6667H6.66667V12Z"></path>
                </svg>
                <svg
                  version="1.0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="40px"
                  height="40px"
                  viewBox="0 0 80 50"
                  preserveAspectRatio="xMidYMid meet"
                  id="checkMark"
                >
                  <g
                    transform="translate(10,50) scale(0.1,-0.1)"
                    fill="#000000"
                    stroke="none"
                  >
                    <path d="M387 282 l-167 -167 -79 79 c-72 72 -101 87 -101 53 0 -7 41 -53 90 -102 l90 -90 182 182 c162 162 181 184 168 198 -14 13 -34 -4 -183 -153z" />
                  </g>
                </svg>
                <span>{t("Check box")}</span>
                <span className="add">{t("Add")}</span>
              </div>
              <div id="mobile-stampside" style={{ display: "none" }}>
                <svg viewBox="0 0 16 16">
                  <path d="M6.66667 1.33337H4V4.00004H6.66667V1.33337ZM12 1.33337H9.33333V4.00004H12V1.33337ZM12 6.66671H9.33333V9.33337H12V6.66671ZM9.33333 12H12V14.6667H9.33333V12ZM4 6.66671H6.66667V9.33337H4V6.66671ZM6.66667 12H4V14.6667H6.66667V12Z"></path>
                </svg>
                <div className="minigrid" id="ministamp">
                  <div id="stampdiv"></div>
                </div>
                <div id="deleteStamp">
                  <span className="add">{t("Delete")}</span>
                </div>
              </div>
              <div className="mobile-miniside" id="addStamp">
                <svg viewBox="0 0 16 16">
                  <path d="M6.66667 1.33337H4V4.00004H6.66667V1.33337ZM12 1.33337H9.33333V4.00004H12V1.33337ZM12 6.66671H9.33333V9.33337H12V6.66671ZM9.33333 12H12V14.6667H9.33333V12ZM4 6.66671H6.66667V9.33337H4V6.66671ZM6.66667 12H4V14.6667H6.66667V12Z"></path>
                </svg>
                <svg
                  version="1.0"
                  xmlns="http://www.w3.org/2000/svg"
                  width="40px"
                  height="40px"
                  viewBox="0 0 320 320"
                  preserveAspectRatio="xMidYMid meet"
                >
                  <g
                    transform="translate(25, 300) scale(0.1,-0.1)"
                    fill="#000000"
                    stroke="none"
                  >
                    <path
                      d="M1013 2665 c-47 -20 -61 -50 -104 -221 -22 -86 -42 -160 -44 -164 -4
                          -7 -44 4 -277 71 -93 26 -133 14 -167 -54 l-23 -48 47 -169 c27 -94 46 -173
                          42 -176 -3 -3 -68 -21 -144 -40 -194 -48 -218 -58 -237 -98 -35 -73 -13 -117
                          128 -255 58 -57 106 -109 106 -115 0 -6 -50 -60 -111 -121 -61 -60 -118 -119
                          -125 -130 -30 -43 -5 -126 47 -153 13 -6 93 -30 177 -51 85 -21 158 -43 162
                          -47 5 -5 -11 -76 -36 -158 -45 -155 -52 -202 -33 -239 31 -61 90 -71 212 -36
                          185 53 218 61 229 56 7 -2 28 -67 47 -143 54 -223 67 -244 158 -244 l48 0 123
                          125 c67 69 126 125 131 125 5 0 57 -51 117 -112 59 -62 117 -118 128 -125 25
                          -15 85 -17 120 -3 35 13 44 35 91 215 46 179 43 176 128 151 190 -57 227 -66
                          265 -66 31 0 49 7 72 28 49 43 49 84 2 243 -54 181 -53 178 -34 188 10 5 85
                          25 167 46 83 21 158 42 167 47 45 22 62 113 30 159 -9 14 -69 75 -132 136
                          l-114 111 126 123 c132 129 145 151 135 217 -10 58 -41 75 -216 118 -86 21
                          -161 42 -168 48 -8 8 -5 32 12 96 76 284 71 256 52 294 -21 45 -60 70 -106 69
                          -20 -1 -98 -20 -175 -42 -124 -37 -176 -48 -176 -38 0 25 -83 326 -95 344 -22
                          32 -79 56 -116 48 -32 -7 -47 -21 -188 -169 l-95 -99 -124 127 c-146 150 -164
                          160 -229 131z"
                    />
                  </g>
                </svg>
                <div id="stamptitle" style={{ display: "inline" }}>
                  {t("Stamp")}
                </div>
                <div id="stamploading" style={{ display: "none" }}>
                  <Stack>
                    <div>
                      <Spinner
                        label={t("loading sign...")}
                        ariaLive="assertive"
                        labelPosition="left"
                        styles={spinnerStyles}
                      />
                    </div>
                  </Stack>
                </div>
                <span className="add">{t("Add")}</span>
              </div>
            </div>
          </div>
        </div>
        <div className="mobile-pdf-padding mobile-dropable">
          <div className="mobile-pdf-header-left">
            <DefaultButton
              type="button"
              styles={{
                root: {
                  width: "80%",
                  minWidth: "80%",
                },
              }}
              onClick={function () {
                props.setPdfSaving(null);
              }}
            >
              <FontIcon
                aria-label="Back"
                iconName="Back"
                className={iconSmallClass}
              />
            </DefaultButton>
          </div>
          <div className="mobile-pdf-header-center">
            <DefaultButton
              type="button"
              id="prev"
              styles={{
                root: {
                  width: "30%",
                  minWidth: "30%",
                },
              }}
            >
              {t("Prev")}
            </DefaultButton>
            <div style={{ width: "30%" }}>
              {t("Page:")} <span id="page_num"></span> /{" "}
              <span id="page_count"></span>
            </div>
            <DefaultButton
              type="button"
              id="next"
              styles={{
                root: {
                  width: "30%",
                  minWidth: "30%",
                },
              }}
            >
              {t("Next")}
            </DefaultButton>
          </div>
          <div className="mobile-pdf-header-right">
            <select
              className="form-select form-select-lg mb-3"
              aria-label=".form-select-lg"
              id="mobile-zoom"
              className="mobile-zoom"
              defaultValue="1"
            >
              <option value="0">{t("Fit to width")}</option>
              <option value="1">x1</option>
              <option value="1.25">x1.25</option>
              <option value="1.5">x1.5</option>
              <option value="2">x2</option>
              <option value="3">x3</option>
              <option value="4">x4</option>
              <option value="5">x5</option>
            </select>
          </div>
        </div>

        <div>
          <center>
            <div>
              <div className="mobile-card" id="cardpdf">
                <div id="pdfviewer">
                  {/* pdf here  */}
                  {textOptionBox ? (
                    isColoring ? (
                      <div
                        contentEditable="false"
                        className="optionBox"
                        id="colorBox"
                      >
                        <span className="colorPicker" id="ob">
                          <svg height="50" width="50" id="ob">
                            <circle
                              id="ob"
                              cx="25"
                              cy="25"
                              r="20"
                              stroke="black"
                              stroke-width="3"
                              fill="black"
                            />
                          </svg>
                        </span>
                        <span className="colorPicker" id="ob">
                          <svg height="50" width="50" id="ob">
                            <circle
                              id="ob"
                              cx="25"
                              cy="25"
                              r="20"
                              stroke="black"
                              stroke-width="3"
                              fill="red"
                            />
                          </svg>
                        </span>
                        <span className="colorPicker" id="ob">
                          <svg height="50" width="50" id="ob">
                            <circle
                              id="ob"
                              cx="25"
                              cy="25"
                              r="20"
                              stroke="black"
                              stroke-width="3"
                              fill="#2658b2"
                            />
                          </svg>
                        </span>
                        <span className="back noselect">
                          <FontIcon
                            aria-label="Back"
                            iconName="Back"
                            className={iconClass}
                            id="ob"
                          />
                        </span>
                      </div>
                    ) : (
                      <div id="textOptionBox">
                        <div style={{ display: "flex" }}>
                          <span className="fontIncrease noselect" id="ob">
                            <FontIcon
                              aria-label="FontIncrease"
                              iconName="FontIncrease"
                              className={iconClass}
                            />
                          </span>
                          <span className="fontDecrease noselect" id="ob">
                            <FontIcon
                              aria-label="FontDecrease"
                              iconName="FontDecrease"
                              className={iconClass}
                            />
                          </span>
                          <span className="changeColor noselect" id="ob">
                            <FontIcon
                              aria-label="Color"
                              iconName="Color"
                              className={iconClass}
                              id="ob"
                            />
                          </span>
                          <span className="duplicateText noselect" id="ob">
                            <FontIcon
                              aria-label="Copy"
                              iconName="Copy"
                              className={iconClass}
                              id="ob"
                            />
                          </span>
                          <span className="deleteTexting noselect">
                            <FontIcon
                              aria-label="Delete"
                              iconName="Delete"
                              className={iconClass}
                            />
                          </span>
                        </div>

                        <div
                          className="fontChange"
                          style={{ display: "grid", fontSize: "20px" }}
                        >
                          <select id="ob" className="font">
                            <option
                              value="Prompt, sans-serif"
                              style={{ fontFamily: "Prompt, sans-serif" }}
                            >
                              Prompt
                            </option>
                            <option
                              value="Sarabun, sans-serif"
                              style={{ fontFamily: "Sarabun, sans-serif" }}
                            >
                              Sarabun
                            </option>
                            <option
                              value='"Source Serif Pro", serif'
                              style={{
                                fontFamily: '"Source Serif Pro", serif',
                              }}
                            >
                              Source Serif Pro
                            </option>
                          </select>
                        </div>
                      </div>
                    )
                  ) : signOptionBox ? (
                    isColoring ? (
                      <div
                        contentEditable="false"
                        className="optionBox"
                        id="colorBox"
                      >
                        <span className="colorPicker" id="ob">
                          <svg height="50" width="50" id="ob">
                            <circle
                              id="ob"
                              cx="25"
                              cy="25"
                              r="20"
                              stroke="black"
                              stroke-width="3"
                              fill="black"
                            />
                          </svg>
                        </span>
                        <span className="colorPicker" id="ob">
                          <svg height="50" width="50" id="ob">
                            <circle
                              id="ob"
                              cx="25"
                              cy="25"
                              r="20"
                              stroke="black"
                              stroke-width="3"
                              fill="red"
                            />
                          </svg>
                        </span>
                        <span className="colorPicker" id="ob">
                          <svg height="50" width="50" id="ob">
                            <circle
                              id="ob"
                              cx="25"
                              cy="25"
                              r="20"
                              stroke="black"
                              stroke-width="3"
                              fill="#2658b2"
                            />
                          </svg>
                        </span>
                        <span className="back noselect">
                          <FontIcon
                            aria-label="Back"
                            iconName="Back"
                            className={iconClass}
                            id="ob"
                          />
                        </span>
                      </div>
                    ) : (
                      <div
                        contentEditable="false"
                        className="optionBox"
                        id="signOptionBox"
                      >
                        <span className="changeColor noselect">
                          <FontIcon
                            aria-label="Color"
                            iconName="Color"
                            className={iconClass}
                            id="ob"
                          />
                        </span>
                        <span className="duplicateSVG noselect" id="ob">
                            <FontIcon
                              aria-label="Copy"
                              iconName="Copy"
                              className={iconClass}
                              id="ob"
                            />
                          </span>
                        <span className="deleteChecking noselect">
                          <FontIcon
                            aria-label="Delete"
                            iconName="Delete"
                            className={iconClass}
                          />
                        </span>
                      </div>
                    )
                  ) : null}
                </div>
              </div>
            </div>
          </center>
        </div>
      </div>
    </div>
  );
};

export default PdfWindow;
